<template>
	<div class="aboutcom">
		<div class="comtop">
			<img src="../../static/img/congtactus.png"/>				
		</div>
	
		<div class="com-detail">
			<div class="com-top-top">
				<h4>联系我们</h4>
				<div class="com-line">
				</div>
				
			</div>
            <div class="cominfo" v-html="news[0].Contentall">
				{{news[0].Contentall}}
				
            </div>
            <div class="map">
            	<iframe width='350' height='300' frameborder='0' scrolling='no' marginheight='0' marginwidth='0' src='http://f.amap.com/5Hhb2_0C24aJI'></iframe>'
            </div>
            
		</div>
	</div>
</template>

<script>
	export default{
		name : 'aboutcom',
		data(){
			return {
				top : [
				{id : 0 , imgsrc : 'static/img/aboutcom.jpg' , title : '联系我们'},
				],
				news : [],
				scrollWatch: true
			}
		},
		mounted(){
			this.getnews();
		},
		methods : {
			getnews(){
      			var that = this;
      			var conlist = [];
     				this.$http.post('http://www.gd-sc.net:9094',{table : 'contentall'},{emulateJSON: true}).then((response) => {
			        for(var i=0 ; i<response.body.recordset.length ; i++){
			        	if(response.body.recordset[i].Alltype == '联系我们'){
			        		conlist.push(response.body.recordset[i])
			        	}
			        }
			        that.news = conlist;
			      })
     			},
		},
	}
</script>

<style>
	.aboutcom{
		position: relative;
		clear: both;
		width: 100%;
		margin: 0 auto;
	}
	.comtop{
		position: relative;
		width: 100%;
		clear: both;
	}
	.comtop img{
		width: 100%;
	}
	.com-detail{
		width: 80%;
		margin: 60px auto;
		position: relative;
		clear: both;
		text-align: left;
	}
	.com-detail h4{
		font-weight: 700;
		margin-left: 50px;
		font-size: 22px;
	}
	.com-line{
		width: 25px;
		height: 3px;
		position: absolute;
		background: #e01313 !important;
		border-radius: 4px;
		top: 8px;
	}
	.com-top-top{
		width: 100%;
		border-bottom: 1px solid #ddd;
		position: relative;
		padding-bottom: 10px;
		margin-bottom: 20px;
	}
	.com-detail h4.small-tit{
		text-align: center;
		width: 500px;
		margin: 0 auto;
		position: relative;
		color: #e01313 !important;
		font-weight: 500;
	}
	.cominfo{
		position: relative;
		clear: both;
		padding: 2%;
	}
	.com-tit{
		width: 40%;
		position: absolute;
		clear: both;
		z-index: 3;
		top: 5vw;
	    left: 11vw;
	    text-align: left;
	    font-size: 22px;
	    color: #333;
	}
	.com-tit p{
		font-size: 14px;
		line-height: 24px;
	}
	.com-tit b{
		font-size: 25px;
	    position: relative;
	    top: 3px;
	}
	.cominfo p{
		color: #666666;
		line-height: 35px;
		margin: 10px auto;
		font-size: 18px;
		text-indent:2em;
	}
	.cominfo img{
		text-align: center;
	}
	.imgcomab{
		width: 49%;
		position: relative;
		clear: both;
		display: inline-block;
		vertical-align: top;
		text-align: center;
	}
	.imgcomab img{
		width: 85%;
	}
	.singleimg,.singlewimg{
		width:100%;
		position: relative;
		margin: 0 auto;
		text-align: center;
	}
	.singleimg img{
		width: 75%;
	}
	.singlewimg img{
		width: 100%;
	}
	.comwenhua h3{
		color: #e03500;
		font-weight: 900;
		font-size: 22px;
	}
	.comwenhua p{
		text-indent:.5em;
	}
	.comwenhua span{
		color: #e03500;
	}
	.comwenhua{
		position: relative;
		margin-top: 45px;	
	}
	.wencom{
		position: relative;
		margin-top: 10px;
	}
	.honor{
		position: relative;
		width: 25%;
		clear: both;
		display: inline-block;
		margin: 20px auto;
		text-align: center;
	}
	.honor img{
		width: 85%;
   		height: 192px;
   		transition: .5s all;
	}
	.honor img:hover{
		transform: scale(1.1);
	}
	.contactright{
		margin-top: 40px;
		margin-left: 2em;
	}
	.map{
		width: 350px;
		margin: 0 auto;
		position: relative;
	}
</style>


// WEBPACK FOOTER //
// src/components/contact.vue